import type * as React from 'react';
import { PriceRelevanceWarning } from '../../components/PriceRelevanceWarning';
import { PriceRelevanceActual } from '../../components/PriceRelevanceActual';
import { useSelector } from 'react-redux';
import { priceRelevanceSelector } from '../../selectors/newbuilding';

export const PriceRelevance = (): React.JSX.Element | null => {
  const priceRelevance = useSelector(priceRelevanceSelector);

  if (!priceRelevance) {
    return null;
  }

  if (priceRelevance.type === 'warning') {
    return (
      <PriceRelevanceWarning
        title={priceRelevance.title}
        label={priceRelevance.label}
        description={priceRelevance.description}
      />
    );
  }

  return (
    <PriceRelevanceActual
      title={priceRelevance.title}
      label={priceRelevance.label}
      description={priceRelevance.description}
    />
  );
};
